import { action } from '@ember/object';
import Component from '@glimmer/component';

interface ComponentArgs {
  interval: number; // interval in milliseconds
  onTick: () => void; // method to call on each interval
}

export default class RunInterval extends Component<ComponentArgs> {
  intervalId?: number;

  @action
  templateDidInsert() {
    this.intervalId = window.setInterval(() => {
      this.args.onTick();
    }, this.args.interval);
  }

  @action
  templateWillDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
